import App from "../App";
import { Routes, Route, Navigate } from "react-router-dom";
import PrivateRoutes from "./PrivateRoute";

import SignIn from "layouts/authentication/sign-in";
import AcceptInvitationPage from "layouts/authentication/accept-invite";
import ClaimRewardPage from "layouts/authentication/claim-reward";
import SignUp from "layouts/authentication/sign-up";
import Dashboard from "layouts/dashboard";
import Mypoint from "layouts/mypoint";
import OrderHistory from "layouts/orderhistory";
import Profile from "layouts/profile";
import Incentive from "layouts/incentive";
import VerifyCustomer from "layouts/authentication/verify-customer";
import VerifyWorkEmails from "layouts/authentication/verify-work-emails";
import SimulateCustomer from "layouts/authentication/simulate-customer";
import OTPSignIn from "layouts/authentication/otp-sign-in";
import { useAuth } from "context";
import { getAuthLocal, setAuthLocal, setGtmCode } from "core/AuthHelper";
import { OtpProvider } from "context/OtpContext";
import { ToastContainer } from "react-toastify";
import config from "config/config";
import UploadReceipts from "layouts/upload-receipts";
import UnsubscribePage from "layouts/no-auth-pages/unsubscribe";

const AppRoutes = () => {
  const landingAccessToken =
    new URL(window.location.href).searchParams.get("landing_page_tokens") || null;
  const gtmCode = new URL(window.location.href).searchParams.get("s") || null;
  if (landingAccessToken) {
    setAuthLocal(JSON.parse(landingAccessToken));
  }
  if (gtmCode) {
    setGtmCode(gtmCode); // Save GTM code to local storage
  }
  const { verifiedCustomer, verifyTokenFunc, auth } = useAuth();
  const authToken = getAuthLocal();
  const ENV = config[process.env.REACT_APP_ENV?.toUpperCase() || "LOCAL"].ENV;

  if (authToken && !verifiedCustomer) {
    verifyTokenFunc(authToken);
  }

  return (
    <>
      <ToastContainer />
      <Routes>
        <Route element={<App />}>
          <Route path="/authentication/accept-invite" element={<AcceptInvitationPage />} />
          <Route path="/authentication/claim-reward" element={<ClaimRewardPage />} />
          <Route
            path="/authentication/sign-in"
            element={
              <OtpProvider length={6}>
                <OTPSignIn />
              </OtpProvider>
            }
          />
          <Route
            path="/authentication/sign-up"
            element={!verifiedCustomer?.verifiedAt ? <SignUp /> : <Navigate to="/dashboard" />}
          />
          <Route path="/authentication/forgot-password" element={<VerifyCustomer />} />
          {(ENV === "local" || ENV === "dev" || ENV === "staging") && (
            <Route path="/incentive/driver" element={<Incentive />} />
          )}

          <Route
            path="/authentication/otp-sign-in"
            element={
              <OtpProvider length={6}>
                <OTPSignIn />
              </OtpProvider>
            }
          />
          <Route path="/simulate" element={<SimulateCustomer />} />
          <Route path="/unsubscribe" element={<UnsubscribePage />} />

          <Route element={<PrivateRoutes />}>
            <Route exact path="/" element={<Navigate to="/dashboard" />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/my-points" element={<Mypoint />} />
            <Route path="/order-history" element={<OrderHistory />} />
            <Route path="/upload-receipts" element={<UploadReceipts />} />
            <Route
              path="/profile"
              element={
                <OtpProvider length={6}>
                  <Profile />
                </OtpProvider>
              }
            />
            <Route path="/authentication/verify-work-emails" element={<VerifyWorkEmails />} />
            <Route path="/authentication/verify-customer" element={<VerifyCustomer />} />
            <Route path="/*" element={<Navigate to="/dashboard" />} />
          </Route>
          <Route index path="/" element={<Navigate to="/authentication/sign-in" />} />
        </Route>
      </Routes>
    </>
  );
};

export { AppRoutes };
